<script lang="ts">
  import { onMount } from 'svelte'
  import MobileNavigation from '../MobileNavigation.svelte'
  import FullScreenNavigation from '../FullScreenNavigation.svelte'
  const matchMediaQuery = window.matchMedia('(max-width: 70em)')

  let mobileNav = matchMediaQuery.matches

  const mediaQueryHandler = (event: MediaQueryListEvent) => {
    if (event.matches) {
      mobileNav = true
    } else {
      mobileNav = false
    }
  }

  onMount(() => {
    matchMediaQuery.addEventListener('change', mediaQueryHandler)
    return () => matchMediaQuery.removeEventListener('change', mediaQueryHandler)
  })
</script>

{#if mobileNav}
  <MobileNavigation />
{:else}
  <FullScreenNavigation />
{/if}

<div class="content">
  <slot />
</div>

<style>
  .content {
    position: relative;
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    align-items: center;
    background-color: var(--tsf-white);
  }
</style>
